// Read-only das telas de CONSULTA (Despesa Viagem e Despesas Diversos).
//
// As telas de detalhe nao sao filhas da tela de consulta: sao ROTA SEPARADA, entao a prop
// `isConsulta` nao chega nelas e o read-only vinha so de `consulta=1` na query -- que e query
// string, o usuario reescreve na barra do navegador. Com as rotas de detalhe liberadas pras
// roles de consulta, entrar sem o parametro devolveria as acoes de escrita, e a
// BusinessCommonAPI nao tem UM `[Authorize]` em endpoint nenhum.
//
// Por isso o read-only vale tambem pelo avesso: sem NENHUMA role de escrita do modulo, e leitura.
// `hasRole` vem do PermissionMixin (dentro do ActionsForm) das telas.
export const derivaConsulta = (query, hasRole, rolesEscrita) =>
  query.consulta === '1' || !rolesEscrita.some(funcao => hasRole(funcao))



// WEBPACK FOOTER //
// ./src/shared/utils/consultaReadonly.js